/* OBLISH JS v7 — CEO Edition
   Image click fix + Hero instant load + All interactions */
(function(){
'use strict';
var SHIP=99900;

/* ==========================================================
   IMAGE CLICK FIX
   JS-based — not dependent on CSS z-index or class names
   Works regardless of Dawn version or card structure
   ========================================================== */
function FixCardClicks(){
  document.querySelectorAll('.card-wrapper,.product-card-wrapper,.grid__item').forEach(function(wrapper){
    /* Already patched */
    if(wrapper.dataset.obClick) return;
    wrapper.dataset.obClick='1';

    /* Find the product URL from any link inside */
    var url=null;
    var links=wrapper.querySelectorAll('a[href]');
    for(var i=0;i<links.length;i++){
      var h=links[i].getAttribute('href');
      if(h&&(h.indexOf('/products/')>-1||h.indexOf('/collections/')>-1)){
        url=h;break;
      }
    }
    if(!url)return;

    /* Make entire wrapper navigate on click */
    wrapper.style.cursor='pointer';
    wrapper.addEventListener('click',function(e){
      /* Don't intercept clicks on actual links or buttons */
      if(e.target.tagName==='A'||e.target.tagName==='BUTTON') return;
      if(e.target.closest('a,button,form')) return;
      window.location.href=url;
    });
  });
}

/* === FREE SHIPPING BAR === */
function ShipBar(){
  var bar=document.getElementById('ob-ship-bar');
  if(!bar)return;
  var txt=document.getElementById('ob-ship-text');
  var fill=document.getElementById('ob-ship-fill');
  function update(total){
    if(total===0){bar.classList.add('is-hidden');return;}
    bar.classList.remove('is-hidden');
    if(total>=SHIP){
      bar.classList.add('is-unlocked');
      if(fill)fill.style.width='100%';
    } else {
      bar.classList.remove('is-unlocked');
      var rem=Math.ceil((SHIP-total)/100);
      var pct=Math.round((total/SHIP)*100);
      if(txt)txt.innerHTML='Add <strong>\u20b9'+rem+'</strong> more for FREE shipping';
      if(fill)fill.style.width=pct+'%';
    }
  }
  fetch('/cart.js').then(function(r){return r.json();}).then(function(c){update(c.total_price);}).catch(function(){bar.classList.add('is-hidden');});
  document.addEventListener('cart:updated',function(e){if(e.detail&&e.detail.cart)update(e.detail.cart.total_price);});
}

/* === CART PULSE === */
function CartPulse(){
  var obs=new MutationObserver(function(){
    var b=document.querySelector('.cart-count-bubble');
    if(b){b.classList.remove('pulse');void b.offsetWidth;b.classList.add('pulse');}
  });
  var b=document.querySelector('.cart-count-bubble');
  if(b)obs.observe(b,{childList:true,subtree:true,characterData:true});
}

/* === RECENTLY VIEWED === */
function RecentlyViewed(){
  var KEY='ob_rv',MAX=8;
  function get(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return[];}}
  function save(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  var pdp=document.querySelector('[data-product-handle]');
  if(pdp){
    var handle=pdp.dataset.productHandle;
    var title=pdp.dataset.productTitle||document.querySelector('.ob-info__title,h1')?document.querySelector('.ob-info__title,h1').textContent.trim():'';
    var img=document.querySelector('#ob-main-img,.product__media img')?document.querySelector('#ob-main-img,.product__media img').src:'';
    var url=window.location.pathname;
    if(handle){
      var list=get().filter(function(p){return p.handle!==handle;});
      list.unshift({handle:handle,title:title,img:img,url:url});
      save(list.slice(0,MAX));
    }
  }
  var grid=document.getElementById('ob-rv-grid');
  if(!grid)return;
  var list=get();
  var cur=pdp?pdp.dataset.productHandle:null;
  var filtered=list.filter(function(p){return p.handle!==cur;}).slice(0,4);
  if(filtered.length<1){var sec=document.getElementById('ob-rv-sec');if(sec)sec.style.display='none';return;}
  grid.innerHTML=filtered.map(function(p){
    return '<a href="'+p.url+'" class="ob-rv-item"><div class="ob-rv-item__img"><img src="'+p.img+'" alt="'+p.title+'" loading="lazy"></div><div class="ob-rv-item__name">'+p.title+'</div></a>';
  }).join('');
}

/* === CURSOR === */
function Cursor(){
  if(window.matchMedia('(pointer:coarse)').matches)return;
  var dot=document.createElement('div');dot.className='ob-cur';
  var ring=document.createElement('div');ring.className='ob-ring';
  document.body.append(dot,ring);
  var mx=0,my=0,rx=0,ry=0;
  window.addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;dot.style.left=mx+'px';dot.style.top=my+'px';},{passive:true});
  (function tick(){rx+=(mx-rx)*0.11;ry+=(my-ry)*0.11;ring.style.left=rx+'px';ring.style.top=ry+'px';requestAnimationFrame(tick);})();
  document.addEventListener('mouseover',function(e){
    var ov=e.target.closest('a,button,.card-wrapper,.ob-hbtn,.ob-ed__cta');
    dot.classList.toggle('hov',!!ov);
    ring.classList.toggle('hov',!!ov);
  });
}

/* === SCROLL PROGRESS === */
function Progress(){
  var b=document.createElement('div');b.className='ob-prog';document.body.prepend(b);
  window.addEventListener('scroll',function(){b.style.width=Math.min(window.scrollY/(document.body.scrollHeight-window.innerHeight)*100,100)+'%';},{passive:true});
}

/* === HEADER SOLID ON SCROLL === */
function Header(){
  var h=document.querySelector('.header-wrapper');if(!h)return;
  window.addEventListener('scroll',function(){h.classList.toggle('solid',window.scrollY>80);},{passive:true});
}

/* === SCROLL REVEAL === */
function Reveal(){
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting)return;
      var el=e.target;
      var idx=Array.from(el.parentElement.children).indexOf(el)%6;
      if(idx>0)el.style.transitionDelay=(idx*0.06)+'s';
      el.classList.add('vis');
      io.unobserve(el);
    });
  },{threshold:0.05,rootMargin:'0px 0px -30px 0px'});
  document.querySelectorAll('.card-wrapper,.collection-card-wrapper,.ob-feature,[data-ob]:not(.vis)').forEach(function(el){
    if(!el.classList.contains('vis')){el.setAttribute('data-ob','');io.observe(el);}
  });
}

/* === COUNTERS === */
function Counters(){
  document.querySelectorAll('[data-count]').forEach(function(el){
    var t=parseInt(el.dataset.count)||0;
    var io=new IntersectionObserver(function(e){if(!e[0].isIntersecting)return;io.disconnect();
      var s=null,d=1600;
      function step(ts){if(!s)s=ts;var p=Math.min((ts-s)/d,1),ease=1-Math.pow(1-p,4);el.textContent=t>=100?Math.round(ease*t)+'+':Math.round(ease*t)+'';if(p<1)requestAnimationFrame(step);else el.textContent=t>=100?t+'+':t+'';}
      requestAnimationFrame(step);
    },{threshold:0.5});io.observe(el);
  });
}

/* === SCROLL TO TOP === */
function ScrollTop(){
  var btn=document.createElement('button');btn.className='ob-totop';btn.innerHTML='&uarr;';btn.setAttribute('aria-label','Back to top');
  document.body.appendChild(btn);
  window.addEventListener('scroll',function(){btn.classList.toggle('show',window.scrollY>600);},{passive:true});
  btn.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
}

/* === MARQUEE === */
function Marquee(){
  document.querySelectorAll('.ob-marquee__track').forEach(function(t){
    if(!t.dataset.duped){t.innerHTML+=t.innerHTML;t.dataset.duped='1';}
  });
}

/* === DISCOUNT BADGES === */
function Badges(){
  document.querySelectorAll('.card-wrapper,.product-card-wrapper').forEach(function(c){
    if(c.querySelector('.ob-badge'))return;
    var prices=[];
    c.querySelectorAll('.money').forEach(function(m){var v=parseFloat(m.textContent.replace(/[^0-9.]/g,''));if(v>0)prices.push(v);});
    if(prices.length<2)return;
    var lo=Math.min.apply(null,prices),hi=Math.max.apply(null,prices);
    if(hi<=lo||lo<=0)return;
    var pct=Math.round((1-lo/hi)*100);if(pct<5)return;
    var b=document.createElement('div');b.className='ob-badge';b.textContent='-'+pct+'%';
    var m=c.querySelector('.card__media,.media-wrapper');
    if(m){m.style.position='relative';m.appendChild(b);}
  });
}

/* === TILT (desktop) === */
function Tilt(){
  if(window.matchMedia('(pointer:coarse)').matches)return;
  document.querySelectorAll('.card-wrapper').forEach(function(card){
    var inner=card.querySelector('.card');if(!inner)return;
    card.addEventListener('mousemove',function(e){
      var r=card.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width-0.5;
      var y=(e.clientY-r.top)/r.height-0.5;
      inner.style.transform='perspective(900px) rotateY('+(x*3.5)+'deg) rotateX('+(-y*3.5)+'deg)';
      inner.style.transition='transform 0.06s ease';
    });
    card.addEventListener('mouseleave',function(){
      inner.style.transform='';
      inner.style.transition='transform 0.6s cubic-bezier(0.16,1,0.3,1)';
    });
  });
}

/* === MAGNETIC BUTTONS === */
function Magnetic(){
  if(window.matchMedia('(pointer:coarse)').matches)return;
  document.querySelectorAll('.ob-hbtn,.ob-ed__cta,.ob-ndot').forEach(function(el){
    el.addEventListener('mousemove',function(e){
      var r=el.getBoundingClientRect();
      var x=(e.clientX-r.left-r.width/2)*0.18;
      var y=(e.clientY-r.top-r.height/2)*0.18;
      el.style.transform='translate('+x+'px,'+y+'px) scale(1.03)';
      el.style.transition='transform 0.1s ease';
    });
    el.addEventListener('mouseleave',function(){
      el.style.transform='';
      el.style.transition='transform 0.45s cubic-bezier(0.16,1,0.3,1)';
    });
  });
}

/* === ANNOUNCEMENT BAR FIX === */
function AnnounceFix(){
  var bar=document.querySelector('.announcement-bar-slider');if(!bar)return;
  var slider=bar.querySelector('.slider--everywhere');
  var slides=Array.from(bar.querySelectorAll('.slideshow__slide'));
  if(!slider||slides.length<2)return;
  Object.assign(slider.style,{position:'relative',overflow:'hidden'});
  slides.forEach(function(slide,i){
    Object.assign(slide.style,{position:i===0?'relative':'absolute',top:'0',left:'0',width:'100%',opacity:i===0?'1':'0',transition:'opacity 0.4s ease',pointerEvents:i===0?'auto':'none'});
  });
  var cur=0;
  function go(n){
    slides[cur].style.opacity='0';slides[cur].style.pointerEvents='none';slides[cur].style.position='absolute';
    slides[n].style.position='relative';slides[n].style.opacity='1';slides[n].style.pointerEvents='auto';
    cur=n;
  }
  var prev=bar.querySelector('[name="previous"]'),nxt=bar.querySelector('[name="next"]');
  if(prev)prev.addEventListener('click',function(e){e.stopImmediatePropagation();go((cur-1+slides.length)%slides.length);},true);
  if(nxt)nxt.addEventListener('click',function(e){e.stopImmediatePropagation();go((cur+1)%slides.length);},true);
  setInterval(function(){go((cur+1)%slides.length);},5500);
  slider.scrollTo=function(){};
}

/* === PAGE TRANSITION === */
function Transition(){
  var ov=document.getElementById('ob-transition');if(!ov)return;
  document.addEventListener('click',function(e){
    var a=e.target.closest('a');
    if(!a||!a.href||a.href===location.href||a.href.startsWith('#')||a.target==='_blank'||a.hostname!==location.hostname)return;
    e.preventDefault();
    var dest=a.href;
    ov.style.cssText='transition:opacity 0.25s ease;opacity:1;pointer-events:all;';
    setTimeout(function(){location.href=dest;},250);
  });
  window.addEventListener('pageshow',function(){
    ov.style.cssText='transition:opacity 0.45s ease;opacity:0;pointer-events:none;';
  });
}

/* === NAV UNDERLINE === */
function NavUnderline(){
  document.querySelectorAll('.header__menu-item,.header__active-menu-item').forEach(function(item){
    if(item.querySelector('.ob-navline'))return;
    var line=document.createElement('span');
    line.className='ob-navline';
    line.style.cssText='position:absolute;bottom:-1px;left:0;width:0;height:1px;background:#0A84FF;transition:width 0.28s cubic-bezier(0.16,1,0.3,1);pointer-events:none;';
    item.style.position='relative';item.appendChild(line);
    item.addEventListener('mouseenter',function(){line.style.width='100%';});
    item.addEventListener('mouseleave',function(){line.style.width='0';});
  });
}

/* ============================================================
   HERO FAST START
   The hero carousel starts with ob-ready class added after
   900ms max. But BEFORE that, cards need to be visible.
   This function ensures the hero never shows blank.
   ============================================================ */
function HeroFastStart(){
  var hero=document.getElementById('ob-hero7');
  if(!hero)return;
  /* Add ob-ready immediately so CSS transitions are available */
  /* Cards will be in correct position from applyOffsets(true) */
  /* This eliminates the 900ms blank screen */
  hero.classList.add('ob-ready');
}

/* === BLUR UP IMAGES === */
function BlurUp(){
  document.querySelectorAll('img[loading="lazy"]').forEach(function(img){
    if(img.complete)return;
    img.style.cssText='filter:blur(8px) saturate(0);transition:filter 0.6s ease,transform 0.6s ease;';
    img.addEventListener('load',function(){img.style.filter='';},{once:true});
  });
}

/* === INIT === */
function init(){
  /* Critical first — run immediately */
  HeroFastStart();
  Cursor();
  Progress();
  Header();
  Marquee();
  AnnounceFix();
  ShipBar();
  CartPulse();
  NavUnderline();
  Transition();
  BlurUp();

  /* Deferred — wait for DOM to settle */
  setTimeout(function(){
    RecentlyViewed();
    Reveal();
    Counters();
    ScrollTop();
    Badges();
    FixCardClicks();
    Tilt();
    Magnetic();
  },200);

  /* Re-run for late-rendering content */
  setTimeout(function(){
    Reveal();
    Badges();
    FixCardClicks();
    Tilt();
  },800);

  setTimeout(function(){
    Reveal();
    Badges();
    FixCardClicks();
  },2500);
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',init);
} else {
  init();
}

/* Re-run on Shopify section reload (theme editor) */
document.addEventListener('shopify:section:load',function(){
  setTimeout(function(){
    Reveal();Badges();FixCardClicks();Tilt();Magnetic();NavUnderline();ShipBar();
  },300);
});

})();
